import { useTranslation } from 'react-i18next'
import { M_Fieldset } from 'src/M_Components'
import { ShipmentFormField } from './ShipmentFormField'

const motherBoundOptions = [
    { label: 'Export', value: 'E' },
    { label: 'Import', value: 'I' },
    { label: 'Transit', value: 'T' },
    { label: 'Internal', value: 'N' },
    { label: 'Operations', value: 'P' },
    { label: 'Other', value: 'O' },
]

export const ShipmentProcess = ({ dataState, setDataState, operation, onOpenBookingDrawer }) => {
    const { t } = useTranslation()

    return (
        <M_Fieldset
            labelInside
            label={
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '20px', marginLeft: '10px' }}>
                    <i className='pi pi-sitemap' style={{ fontSize: '18px' }} />
                    {t('Process')}
                </div>
            }
            elements={
                <div style={{ display: 'flex', flexDirection: 'column', padding: '10px' }}>
                    <div style={{ display: 'flex', alignItems: 'flex-end', flexWrap: 'wrap' }}>
                        {/* Booking selector */}
                        <div
                            onClick={onOpenBookingDrawer}
                            style={{
                                margin: '5px',
                                flex: '1 1 250px',
                                display: 'flex', alignItems: 'center', gap: '10px',
                                padding: '8px 14px', borderRadius: '8px',
                                border: `1px solid ${dataState.IdBooking ? 'var(--color-blue)' : 'var(--color-red)'}`,
                                cursor: 'pointer',
                                backgroundColor: 'var(--color-white)',
                                minHeight: '56px',
                            }}
                        >
                            <i className='pi pi-book' style={{ fontSize: '16px', color: 'var(--color-blue)' }} />
                            <div style={{ display: 'flex', flexDirection: 'column', lineHeight: 1.3 }}>
                                <span style={{ fontSize: '11px', color: 'var(--color-gray)', fontWeight: 500, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                    {t('BookingNumber')} *
                                </span>
                                <span style={{ fontSize: '15px', fontWeight: 700, color: (dataState.ProcessKey || dataState.BookingNumber) ? 'var(--color-blue)' : 'var(--color-gray)' }}>
                                    {dataState.ProcessKey || dataState.BookingNumber || '—'}
                                    <i className='pi pi-search' style={{ fontSize: '11px', marginLeft: '6px', opacity: 0.6 }} />
                                </span>
                            </div>
                        </div>

                        <ShipmentFormField
                            fields={{ display: t('MotherBound'), code: 'MotherBound', type: 'select', options: motherBoundOptions }}
                            index={1}
                            data={dataState}
                            setData={setDataState}
                            options={motherBoundOptions}
                        />
                    </div>

                    <div style={{ display: 'flex', alignItems: 'flex-end', flexWrap: 'wrap' }}>
                        <ShipmentFormField
                            fields={{ display: t('LineCode'), code: 'LineCode', type: 'disabled', size: '180px' }}
                            index={2}
                            data={dataState}
                            setData={setDataState}
                        />
                        <ShipmentFormField
                            fields={{ display: t('ServiceCode'), code: 'ServiceCode', type: 'disabled', size: '180px' }}
                            index={3}
                            data={dataState}
                            setData={setDataState}
                        />
                        <ShipmentFormField
                            fields={{ display: t('VesselCode'), code: 'VesselCode', type: 'disabled', size: '180px' }}
                            index={4}
                            data={dataState}
                            setData={setDataState}
                        />
                        <ShipmentFormField
                            fields={{ display: t('Voyage'), code: 'VoyageNumber', type: 'disabled', size: '180px' }}
                            index={5}
                            data={dataState}
                            setData={setDataState}
                        />
                    </div>
                </div>
            }
        />
    )
}
